import '../../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import 'react';
import '../../../../@ant-design/cssinjs/es/StyleContext.js';
import { unit } from '../../../../@ant-design/cssinjs/es/util/index.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../../stylis/dist/umd/stylis.js';
import '../../../../rc-util/es/warning.js';
import '../../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
const genSummaryStyle = token => {
  const {
    componentCls,
    lineWidth,
    tableBorderColor,
    calc
  } = token;
  const tableBorder = `${unit(lineWidth)} ${token.lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-summary`]: {
        position: 'relative',
        zIndex: token.zIndexTableFixed,
        background: token.tableBg,
        '> tr': {
          '> th, > td': {
            borderBottom: tableBorder
          }
        }
      },
      [`div${componentCls}-summary`]: {
        boxShadow: `0 ${unit(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
      }
    }
  };
};
var genSummaryStyle$1 = genSummaryStyle;
export { genSummaryStyle$1 as default };
//# sourceMappingURL=summary.js.map
